async function getClientIp() {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return null;
    }
}

async function getCountryCode(ip) {
    try {
        const randomNum = Math.floor(Math.random() * 100000) + 1;
        const response = await fetch(`http://ipwhois.pro/${ip}?key=mDP1WDJVt2fXmKEE&random=${randomNum}`);
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        const data = await response.json();
        return data.country_code;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        return 'UNKNOWN';
    }
}

async function main() {

    console.log(12345);
    const clientIp = await getClientIp();
    if (clientIp === null) {
        console.error('Could not retrieve client IP address');
        return;
    }

    const countryCode = await getCountryCode(clientIp);

    console.log('countryCode [' + countryCode + ']');

    /*
    function clickElementByVariantId(id) {
        document.querySelector('[data-variant-id="' + id + '"]').click();
        console.log('click [' + id + ']');
    }

    if (['UK', 'GB', 'HK', 'SG', 'MY', 'AE', 'SA'].includes(countryCode)) {
        clickElementByVariantId(2);
    } else if (['US', 'CA', 'TW', 'PR', 'HI'].includes(countryCode)) {
        clickElementByVariantId(3);
    } else if (['AU', 'CN'].includes(countryCode)) {
        clickElementByVariantId(4);
    }
        */
 
        console.log(localStorage.getItem('country_auto_selected'));
        if (localStorage.getItem('country_auto_selected')) {
            return;
        }

        try {
         
        console.log("countryCode: "+countryCode);
            if (!countryCode) return;

            const form =
            document.querySelector('#HeaderCountryForm') ||
            document.querySelector('#HeaderCountryMobileForm');

            if (!form) return;

            const input = form.querySelector(
            'input[name="country_code"]'
            );

            if (!input) return;

            if (input.value === countryCode) {
            localStorage.setItem(
                'country_auto_selected',
                'true'
            );
            return;
            }

            input.value = countryCode;

            localStorage.setItem(
            'country_auto_selected',
            'true'
            );

            form.requestSubmit();
        } catch (err) {
            console.error('Geo localization error', err);
        }
}

main();
